import { useEntities } from 'modules/push-api/hooks/useEntities';
import { FormNamespaceProvider } from 'modules/taboola-common-frontend-modules/formData/FormNamespaceProvider';
import { SubscriptionEntity } from '../SubscriptionEntity/SubscriptionEntity';
import styles from './subscriptionEntities.module.scss';

export const SubscriptionEntities = () => {
    const { entities } = useEntities();

    return (
        <div className={styles['col-list']}>
            <FormNamespaceProvider field="entities">
                {entities?.map(({ id: key }, index) => {
                    return (
                        <FormNamespaceProvider field={index} itemKey={key} key={`entity_${key}`}>
                            <SubscriptionEntity itemKey={`entity_${key}`} entityIndex={index} />
                        </FormNamespaceProvider>
                    );
                })}
            </FormNamespaceProvider>
        </div>
    );
};
